import { filter } from 'lodash'
const initialState = {
  notifications: [],
  deviceId: null,
  deviceType: null,
  isInitiatingPush: null,
  pushInitialized: null,
  allowPushNotification: null
}

const getFadeClass = type => {
  if (type === 'danger') return 'animate__animated animate__bounceIn'
  return 'animate__animated animate__fast animate__fadeIn'
}

const notifications = (state = initialState, action) => {
  switch (action.type) {
    case 'ADD_NOTIFICATION':
      return { ...state, notifications: [...state.notifications, { ...action.notification, fadeClass: getFadeClass(action.notification.type) }] }
    case 'REMOVE_NOTIFICATION':
      // Creates a new Array without the element we want to remove
      return { ...state, notifications: filter(state.notifications, ({ _id }) => _id !== action._id) }
    case 'SET_LOGGED_OUT':
      // Persists the notification after a logout
      return state
    case 'SET_ALLOW_PUSH_NOTIFICATION':
      return { ...state, allowPushNotification: action.allowPushNotification }
    case 'SET_PUSH_INITIALIZED':
      return { ...state, isInitiatingPush: null, pushInitialized: true, deviceId: action.deviceId, deviceType: action.deviceType }
    case 'SET_IS_INITIATING_PUSH':
      return { ...state, isInitiatingPush: true }
    case 'FADE_OUT_NOTIFICATION':
      return {
        ...state,
        notifications: state.notifications.map(notification =>
          notification._id === action._id ? { ...notification, fadeClass: action.fadeClass } : notification
        )
      }
    default:
      return state
  }
}

export default notifications
